export const getCleanedText = (...args: any[]) => {
  const validArgs: string[] = [];
  args.forEach((arg: any) => {
    if (arg) {
      validArgs.push(arg);
    }
  });
  return validArgs.join(', ');
};
